import React, { Component } from "react";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import { message } from "antd";
import PersonalInfoComponent from "../basicdetails/PersonalInfo";
import EcasPersonalInfoComponent from "../ecasBasicDetails/PersonalInfo";
import { RESEARCH_TYPE } from "../../utils/consts";

import LEStudyPersonalInfoComponent from "../leStudy/demographicsComponents/als/PersonalInfo";
import LEStudyPersonalInfoComponentControls from "../leStudy/demographicsComponents/controls/PersonalInfo";

export default class PersonalInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active_step: "1",
    };
  }
  selectUserType = (param) => {
    this.setState({
      active: param,
    });
  };
  continue = () => {
    if (!this.state.active) {
      message.warning("Please select account");
      return;
    }
  };
  onChange = (date, dateString) => {
    this.setState({
      date_of_birth: date,
    });
  };
  set_active_step = (step) => {
    this.setState({ active_step: step });
  };
  render() {
    return (
      <div>
        <Header />
        <div className="main-content demographics-section-wrapper">
          <div className="container">
            <div className="row">
              <div className="col-lg-11 m-auto">
                <div className="demographic-single-section">
                  <a
                    href="/about-me"
                    style={{ width: 95 }}
                    className="back-arrow"
                  >
                    <box-icon
                      name="chevron-left"
                      color="#fff"
                      style={{ position: "relative", top: 1 }}
                    ></box-icon>
                    Back
                  </a>
                  {RESEARCH_TYPE == "Asymptomatic Study" && (
                    <PersonalInfoComponent
                      set_active_step={this.set_active_step}
                      is_update={true}
                    />
                  )}
                  {RESEARCH_TYPE == "ECAS Study" && (
                    <EcasPersonalInfoComponent
                      set_active_step={this.set_active_step}
                      is_update={true}
                    />
                  )}
                  {RESEARCH_TYPE == "LE Study" && (
                    <>
                      {localStorage.getItem("ap_relation_to_als") ==
                        "Living with ALS" && (
                        <LEStudyPersonalInfoComponent
                          set_active_step={this.set_active_step}
                          is_update={true}
                        />
                      )}
                      {localStorage.getItem("ap_relation_to_als") ==
                        "Healthy control" && (
                        <LEStudyPersonalInfoComponentControls
                          set_active_step={this.set_active_step}
                          is_update={true}
                        />
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
